import React from 'react';
import './HomeSection.css';

const HomeSection = () => {
  return (
    <section id="home" className="section home-section">
      <div className="content">
        
        {/* --- Link do WhatsApp atualizado para o número do Hotel Imperial --- */}
        <a href="https://wa.me/5535988171649" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
          Faça sua reserva
        </a>
      </div>
    </section>
  );
};

export default HomeSection;